import { ChangeDetectionStrategy, Component, inject, input, signal, TemplateRef, viewChild } from '@angular/core'

import { MatBottomSheet, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { HorizontalScrollButtons } from '../../shared/horizontal-scroll-buttons/horizontal-scroll-buttons'
import { NewlinesToBrPipe } from '../../shared/newlines-to-br-pipe'
import { ResponsiveUi } from '../../shared/responsive-ui'
import { Topic } from '../../interactions/interaction-interface'
import { Topics } from '../topics'

@Component({
	selector: 'app-topic-buttons',
	imports: [
    MatBottomSheetModule, MatButtonModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatIconModule, MatTooltipModule,
    HorizontalScrollButtons, NewlinesToBrPipe,
	],
	templateUrl: './topic-buttons.html',
	styleUrl: './topic-buttons.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopicButtons {
	private readonly bottomSheet = inject(MatBottomSheet)
	private readonly dialog = inject(MatDialog)
	private readonly responsiveUi = inject(ResponsiveUi)
	private readonly topicsService = inject(Topics, { optional: true })

	readonly topics = input.required<Topic[]>()

	private readonly topicNotesTemplate = viewChild<TemplateRef<HTMLElement>>('topicNotesSheet')
	private readonly topicNotesDialogTemplate = viewChild<TemplateRef<HTMLElement>>('topicNotesDialog')

	protected readonly selectedTopic = signal<Topic|null>(null)
	private bottomSheetRef?: MatBottomSheetRef<HTMLElement>

	/** Show the selected topic notes in a dialog, bottom sheet, or side panel depending on viewport and context. */
	protected openTopicNotes(topic: Topic): void {
		this.selectedTopic.set(topic)
		if (this.responsiveUi.isSmallViewport()) {
			this.bottomSheetRef = this.bottomSheet.open(this.topicNotesTemplate()!, { panelClass: 'topic-bottom-sheet' })
		} else if (this.topicsService) {
			this.topicsService.selectedTopic.set(topic)
		} else {
			this.dialog.open(this.topicNotesDialogTemplate()!, { disableClose: false })
		}
	}

	/** Show topic notes in the side panel on desktop hover/focus. No-op on mobile or without a Topics provider. */
	protected showTopicNotes(topic: Topic): void {
		if (this.topicsService && !this.responsiveUi.isSmallViewport()) {
			this.topicsService.selectedTopic.set(topic)
		}
	}

	/** Close the topic notes bottom sheet if one is open. */
	protected closeTopicNotes(): void {
		this.bottomSheetRef?.dismiss()
	}

}
